import { ButtonType, ButtonWidget } from '@tableau/widgets';
import * as React from 'react';

import { getAppStore } from '~src/app/AppStore';
import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/common/utilities/ImgUrl';

import { createNewConnectedApplication } from '../actions/ConnectedApplicationActions';

export const CreateConnectedApplicationAction = {
  title: () => 'New Connected Application',
  icon: imgPath('site_content_type_small.svg'),
  createReduxAction: createNewConnectedApplication,
  isDivider: false
};

export function newConnectedApplicationButton(): JSX.Element {
  const reduxAction = CreateConnectedApplicationAction.createReduxAction();
  const handleClick = () => getAppStore().dispatch(reduxAction);
  return (
    <ButtonWidget
      children={Messages.connectedApplicationNewConnectedApplicationButton()}
      buttonType={ButtonType.Outline}
      handleClick={handleClick}
      tb-test-id={'action-create-new-connected-application'}
      testId={'action-create-new-connected-application'}/>
  );
}
